import type { components } from '@connected/api-client/api.generated';

import { Button } from '@connected/ui/components/button';
import { Trash2 } from 'lucide-react';

import { useObservation } from '@/hooks/queries/use-observations';

import { useDeleteObservation } from '../hooks/use-observation-mutations';

export type DeleteObservationButtonProps = {
    item: components['schemas']['ListElectricalProjectObservationQueryResultObservation'];
    electricalProjectVersionId: string;
};

export function DeleteObservationButton({
    item,
    electricalProjectVersionId,
}: DeleteObservationButtonProps) {
    const { data } = useObservation({
        electricalProjectObservationId: item.ElectricalProjectObservationId!,
        electricalProjectVersionId,
    });

    const { mutation: deleteObservationMutation } = useDeleteObservation({
        electricalProjectVersionId,
        observationData: data?.observation || null,
    });

    return (
        <Button
            variant="ghost"
            onClick={(event) => {
                event.stopPropagation();
                deleteObservationMutation.mutate({
                    params: {
                        query: {
                            ElectricalProjectObservationId: item.ElectricalProjectObservationId!,
                        },
                    },
                });
            }}
        >
            <Trash2 className="w-4 h-4" />
        </Button>
    );
}
